/** Expande códigos de evaluación solo en texto visible; preserva ids y rutas. */
export function assessmentNames(text: string): string {
  return text.replace(/\b(EA|TF|CL)\b/g, (code) => ({
    EA: "evaluaciones parciales",
    TF: "trabajo final",
    CL: "controles de lectura",
  })[code] ?? code).replace(/evaluaciones de avance/gi, "evaluaciones parciales");
}

const DISPLAY_FIELDS = new Set([
  "title", "subtitle", "label", "body", "markdown", "text", "description",
  "question", "explanation", "hint", "caption", "formula", "total_label",
  "lead", "goal", "deliverable", "criteria", "tags", "next_milestone",
]);

export function normalizeAssessmentCopy<T>(value: T, field = ""): T {
  if (typeof value === "string") {
    return (DISPLAY_FIELDS.has(field) ? assessmentNames(value) : value) as T;
  }
  if (Array.isArray(value)) {
    return value.map((item) => normalizeAssessmentCopy(item, field)) as T;
  }
  if (value && typeof value === "object") {
    return Object.fromEntries(Object.entries(value).map(([key, item]) =>
      [key, normalizeAssessmentCopy(item, key)],
    )) as T;
  }
  return value;
}
